/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_DisclaimerInputs */

const en_mk_calc_disclaimer = /** @type {(inputs: Mk_Calc_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparison prices come from each product’s own pricing page on 6 September 2026 (annual billing where offered), converted at Rp 17,600 per US dollar. Prices and rates change; check with the vendor before deciding. This compares seat cost, not feature coverage — each product is strong at different things.`)
};

const id_mk_calc_disclaimer = /** @type {(inputs: Mk_Calc_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga pembanding diambil dari halaman harga resmi masing-masing produk pada 6 September 2026 (tagihan tahunan bila tersedia) dan dikonversi dengan kurs Rp 17.600 per dolar AS. Harga dan kurs bisa berubah; periksa langsung ke penyedianya sebelum mengambil keputusan. Perbandingan ini menyamakan biaya kursi, bukan cakupan fitur — tiap produk kuat di hal yang berbeda.`)
};

/**
* | output |
* | --- |
* | "Comparison prices come from each product’s own pricing page on 6 September 2026 (annual billing where offered), converted at Rp 17,600 per US dollar. Prices ..." |
*
* @param {Mk_Calc_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_disclaimer = /** @type {((inputs?: Mk_Calc_DisclaimerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_DisclaimerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_disclaimer(inputs)
	return en_mk_calc_disclaimer(inputs)
});